import Vue from 'vue';
import Component from 'vue-class-component';
import template from './forgot-password.html';

@Component({ template })
export default class ForgotPassword extends Vue {}
